export const offerFormula = "2 livres complémentaires + 5 bonus offerts";
export const mainCtaLabel = "Je veux les 2 livres + les 5 bonus pour 27 $ US";
export const ctaSubline = "PDF envoyés par e-mail · Paiement unique · Garantie satisfait ou remboursé de 10 jours";

export const heroImage = "https://cdn.magicpatterns.com/uploads/uJdeFAiCiXgij8Uc7vT5ee/Paquete_de_guitarra_con_50_tablaturas.png";

export const heroTrust = ["Livré par e-mail", "PDF à télécharger et à imprimer", "Paiement unique"];

export const heroChecklist = [
  "Le livre théorique",
  "Le livre pratique",
  "5 bonus offerts",
  "Des PDF à télécharger et à imprimer",
];

export const heroQuotes = [
  { quote: "Avant, je perdais des heures à chercher du matériel de guitare. Maintenant, j'imprime et j'enseigne.", author: "SARAH J. · PROFESSEURE DE GUITARE" },
  { quote: "Mes débutants grattent de vrais morceaux dès la troisième semaine. Les fiches d'accords et de rythmique valaient à elles seules le prix.", author: "DANIEL M. · PROFESSEUR DE GUITARE" },
  { quote: "Tous les professeurs de guitare de mon école suivent désormais le même plan. Les parents voient enfin les progrès.", author: "LAURA C. · DIRECTRICE D'ÉCOLE DE GUITARE" },
];

export const pains = [
  "Vous passez des heures sur YouTube et les sites de tablatures à chercher du matériel professionnel… pour ne trouver que du contenu médiocre",
  "Vous redistribuez les mêmes fiches d'accords parce que vous n'avez plus de matériel nouveau",
  "Vous n'avez pas de progression claire pour le trimestre, du premier accord aux premiers morceaux",
  "Vous perdez des élèves dès le deuxième mois parce qu'ils s'ennuient avec de vieilles méthodes poussiéreuses",
  "Vous vous sentez mal préparé et stressé avant chaque cours",
  "Vous êtes un excellent guitariste, mais épuisé d'improviser chaque séance",
];

export const books = [
  {
    label: "LIVRE 1",
    title: "Le livre théorique",
    desc: "Pour consulter les notions essentielles et appuyer vos explications pendant les cours.",
    image: "https://cdn.magicpatterns.com/patterns/generated-images/a763eed1-c019-4e10-842a-6c66068c639a.jpg",
  },
  {
    label: "LIVRE 2",
    title: "Le livre pratique",
    desc: "Pour travailler avec des exercices et appliquer les notions avec vos élèves.",
    image: "https://cdn.magicpatterns.com/patterns/generated-images/4b62b9da-435c-4386-ab50-fd5985bb4fd1.jpg",
  },
];

export const bonuses = [
  { image: "https://cdn.magicpatterns.com/patterns/generated-images/e5616766-9fcc-43b8-8e77-ace9082cfc69.jpg", title: "La bibliothèque de tablatures pour débuter", desc: "Une collection de tablatures accessibles aux débutants, prêtes à imprimer et à distribuer dès le premier cours." },
  { image: "https://cdn.magicpatterns.com/patterns/generated-images/0b82cd07-27a7-4c7f-82eb-847ce4d917c5.jpg", title: "Le guide des mélodies pour débutants", desc: "Des mélodies simples pour que les nouveaux élèves jouent quelque chose de reconnaissable dès les premières semaines." },
  { image: "https://cdn.magicpatterns.com/patterns/generated-images/68f20178-b5c0-413f-a91d-3cd598c183c6.jpg", title: "Le calendrier d'exercices sur 30 jours", desc: "Un plan de pratique jour par jour à imprimer et à envoyer à la maison, pour que les progrès continuent entre deux cours." },
  { image: "https://cdn.magicpatterns.com/patterns/generated-images/001dc7ab-c103-411a-ba00-557c6ca96d11.jpg", title: "Le pack d'exercices techniques", desc: "Des exercices ciblés de doigté, de médiator et de changements d'accords, classés par niveau de difficulté." },
  { image: "https://cdn.magicpatterns.com/patterns/generated-images/3aabd506-d90f-437d-a14c-cbffb53a835e.jpg", title: "Les fiches de cours prêtes à l'emploi", desc: "Des fiches avec objectifs, exercices et devoirs, à imprimer telles quelles ou à adapter à chaque élève." },
];

export const packSummary = [
  "Le livre théorique",
  "Le livre pratique",
  "Les 5 bonus offerts",
  "Des PDF à télécharger et à imprimer",
];

export const testimonials = [
  { name: "Sarah J.", role: "Professeure de guitare", photo: "https://cdn.magicpatterns.com/uploads/qp5PF1xiXiEjuLZPHGDaFi/pasted-image.jpg", quote: "Avant, je perdais des heures chaque semaine rien qu'à chercher quoi enseigner. Maintenant, j'imprime et j'enseigne. Mes élèves progressent plus vite et restent motivés." },
  { name: "Laura C.", role: "Directrice d'école de guitare", photo: "https://cdn.magicpatterns.com/uploads/521tnykBMiG5M8GEcBA5fL/pasted-image.jpg", quote: "Tous les professeurs de guitare de mon école travaillent désormais avec le même matériel. Les fiches de cours, à elles seules, rendaient l'achat évident." },
  { name: "Rachel T.", role: "Studio de guitare privé", photo: "https://cdn.magicpatterns.com/uploads/c6A6XfNYPEUdjXt4oDnM1k/pasted-image.jpg", quote: "Avec les fiches de cours, je peux montrer aux parents ce que nous avons travaillé, au lieu de simplement dire « elle se débrouille bien »." },
  { name: "Daniel M.", role: "Professeur de guitare", photo: "https://cdn.magicpatterns.com/uploads/4dH7XmgnJKHGxQyzmmR95T/pasted-image.jpg", quote: "Les exercices techniques et la bibliothèque de tablatures ont fait jouer de vrais morceaux à mes débutants dès la troisième semaine." },
];

export const faqs = [
  { q: "Est-ce un livre physique ? Quel est le format ?", a: "C'est 100 % numérique, en PDF — sans vidéos ni livres audio. Les 2 livres et les 5 bonus sont des PDF que vous recevez par e-mail, à télécharger et à imprimer." },
  { q: "Que contient exactement le pack ?", a: "Le livre théorique, le livre pratique et 5 bonus offerts : la bibliothèque de tablatures pour débuter, le guide des mélodies pour débutants, le calendrier d'exercices sur 30 jours, le pack d'exercices techniques et les fiches de cours prêtes à l'emploi." },
  { q: "Puis-je adapter le matériel à chaque élève ?", a: "Oui. Le matériel vous fait gagner du temps de préparation, tout en vous laissant libre de l'adapter au niveau et au rythme de chaque élève." },
  { q: "Comment vais-je recevoir le matériel ?", a: "Juste après votre paiement, vous recevez un e-mail avec le lien pour télécharger les 2 livres et les 5 bonus en PDF." },
  { q: "Et si je ne suis pas entièrement satisfait ?", a: "Vous êtes couvert par notre garantie satisfait ou remboursé de 10 jours. Un simple e-mail à support@stockdigital.shop suffit, sans aucune question." },
];

export const beforeList = [
  "Des heures chaque semaine à chercher des tablatures et des fiches",
  "Cours improvisés · Aucune progression claire",
  "Élèves ennuyés par de vieilles méthodes poussiéreuses",
  "Élèves qui abandonnent avant leur premier morceau complet",
  "Dimanches soir perdus à mettre en page des fiches",
];

export const afterList = [
  "Un livre théorique pour expliquer, un livre pratique pour appliquer",
  "Du matériel prêt à imprimer, que vous adaptez à chaque élève",
  "Des tablatures et des mélodies qu'ils ont vraiment envie de jouer",
  "Des morceaux reconnaissables dès les premières semaines",
  "Tout votre trimestre préparé · Vos dimanches retrouvés",
];
